import { Component, EventEmitter, Input, Output, ViewEncapsulation } from "@angular/core";
import { fuseAnimations } from "@nx-workspace/fuse";
import {
    ButtonSize,
    ButtonVariant,
    ButtonColor,
    ButtonWrapperComponent,
} from "../button-wrapper/button-wrapper.component";
import { CommonModule } from "@angular/common";
import { MatMenuModule } from "@angular/material/menu";
import { MatButtonModule } from "@angular/material/button";
import { MatDividerModule } from "@angular/material/divider";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatIconModule } from "@angular/material/icon";
import { OverlayModule } from "@angular/cdk/overlay";

@Component({
    selector: "dropdown",
    templateUrl: "./dropdown.component.html",
    styleUrls: ["./dropdown.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    standalone: true,
    imports: [
        CommonModule,
        MatMenuModule,
        MatButtonModule,
        MatDividerModule,
        MatButtonToggleModule,
        MatIconModule,
        ButtonWrapperComponent,
        OverlayModule,
    ],
})
export class DropdownComponent {
    @Input() text: string = "";

    @Input() color: ButtonColor = "neutral";

    @Input() size: ButtonSize = "medium-button";

    @Input() variant: ButtonVariant = "flat";

    @Output() clicked = new EventEmitter<boolean>();

    @Input() bold: boolean = false;

    @Input() disabled: boolean = false;

    @Input() items: { title: string }[] = [];
    @Output() selected = new EventEmitter<any>();

    selectItem(item: any) {
        this.selected.emit(item);
    }
}
